<div class="loading-icon" *ngIf="!isSmall">
  <div class="icon"></div>
</div>

<div class="lds-ellipsis" *ngIf="isSmall">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>